"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var service_service_1 = require("src/app/Services/service.service");
var WickedApiClient_1 = require("src/app/api/WickedApiClient");
var router_1 = require("@angular/router");
// import { UploadFileComponent } from 'src/app/Components/upload-file/upload-file.component';
var upload_file_queue_component_1 = require("src/app/Components/upload-file-queue/upload-file-queue.component");
var http_1 = require("@angular/common/http");
var FileModels_1 = require("src/app/Models/FileModels");
var AuthHeaders_1 = require("src/app/api/AuthHeaders");
var drag_drop_1 = require("@angular/cdk/drag-drop");
var LocalModels_1 = require("src/app/api/LocalModels");
var moment = require("moment");
var captcha_service_1 = require("../../Services/captcha.service");
var confirmation_sheet_component_1 = require("../../Messages/confirm-sheet/confirmation-sheet.component");
var EmojiHelper_1 = require("../../Helpers/EmojiHelper");
var DropzoneHeper_1 = require("../../Helpers/DropzoneHeper");
var subscribtion_service_1 = require("../../Services/subscribtion.service");
var operators_1 = require("rxjs/operators");
var premium_ad_token_paymen_component_1 = require("../../Components/premium-ad-token/premium-ad-token-paymen.component");
var geolocation_service_1 = require("../../Services/geolocation.service");
var previousroute_service_1 = require("../../Services/previousroute.service");
var environment_1 = require("src/environments/environment");
var AdView;
(function (AdView) {
    AdView[AdView["Advertisement"] = 0] = "Advertisement";
    AdView[AdView["Payment"] = 1] = "Payment";
})(AdView = exports.AdView || (exports.AdView = {}));
var AdType;
(function (AdType) {
    AdType[AdType["Free"] = 0] = "Free";
    AdType[AdType["Premium"] = 1] = "Premium";
    AdType[AdType["ThirdParty"] = 2] = "ThirdParty";
})(AdType = exports.AdType || (exports.AdType = {}));
var AdvEditComponent = /** @class */ (function () {
    function AdvEditComponent(captchaService, HttpClient, fb, services, route, subscriptionService, geolocationService, previouseRouteService, router) {
        this.captchaService = captchaService;
        this.HttpClient = HttpClient;
        this.fb = fb;
        this.services = services;
        this.route = route;
        this.subscriptionService = subscriptionService;
        this.geolocationService = geolocationService;
        this.previouseRouteService = previouseRouteService;
        this.router = router;
        this._captchaResolvedFlag = false;
        this.currentTitleCursorPosition = -1;
        this.currentDescriptionCursorPosition = -1;
        this._adView = AdView.Advertisement;
        this._adType = AdType.Free;
        this._advId = null;
        this._userPremiumAdTokens = 0;
        this._userThirdPartyAdTokens = 0;
        this.personTypes = [{ text: "I'm a Woman", value: "Woman" }, { text: "I'm a Man", value: "Man" }, { text: "I'm a Transgender", value: "Trans" }, { text: "We are a Couple", value: "Couple" }];
        this.personTypesMap = {
            "Woman": [1, 2, 3, 4, 17],
            "Man": [5, 6, 7, 8, 17],
            "Trans": [13, 14, 15, 16, 17],
            "Couple": [9, 10, 11, 12, 17],
        };
        this.displayTexts = {
            1: "seeking Men",
            2: "seeking Women",
            3: "seeking Couples",
            4: "seeking Transgenders",
            5: "seeking Women",
            6: "seeking Men",
            7: "seeking Couples",
            8: "seeking Transgenders",
            9: "seeking Women",
            10: "seeking Men",
            11: "seeking Couples",
            12: "seeking Transgenders",
            13: "seeking Women",
            14: "seeking Men",
            15: "seeking Couples",
            16: "seeking Transgenders",
            17: "Missed Connections",
        };
        this.selectedPersonType = "";
        this.regionFilter = new forms_1.FormControl();
        this.subregionFilter = new forms_1.FormControl();
        this.categories = [];
        this.regions = [];
        this.subRegions = [];
        this.images = [];
        this._specialUser = null;
        this._isUserDemo = null;
        this._isUserAdmin = null;
        this._isDemoAd = false;
        this.This = this;
        this.imagesChanged = false;
        this.controlNames = [
            { name: 'title', title: 'Title' },
            { name: 'nick', title: 'Nick' },
            { name: 'content', title: 'Description' },
            { name: 'age', title: 'Age' },
            { name: 'region', title: 'Region' },
            { name: 'subregion', title: 'Sub Region' },
            { name: 'postalcode', title: 'ZIP Code' },
            { name: 'casualDating', title: 'Casual dating' },
            { name: 'relationShips', title: 'Relationship' },
            { name: 'termAccepted', title: "Terms Accept" }
        ];
        this.advIsLoading = false;
        this._isExpired = false;
        this._submitInProgress = false;
        this.emojis = [];
        this._dragOn = false;
        this._termsNotAccepted = true;
    }
    AdvEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this._adType != 2) {
            this.subscriptionService.GetUserPremiumAdTokens().then(function (response) {
                _this._userPremiumAdTokens = response;
                if (_this._userPremiumAdTokens > 0 && _this.isNew()) {
                    _this._adType = AdType.Premium;
                }
            });
        }
        else {
            this.subscriptionService.GetUserThirdPartyAdTokens().then(function (response) {
                _this._userThirdPartyAdTokens = response;
                if (_this._userThirdPartyAdTokens > 0 && _this.isNew()) {
                    _this._adType = AdType.ThirdParty;
                    _this._adView = 0;
                }
            });
        }
        this.advForm = this.fb.group({
            region: [null, this.isThirdPartyAd ? null : forms_1.Validators.required],
            subregion: [null, this.isThirdPartyAd ? null : forms_1.Validators.required],
            postalCode: [null, this.isThirdPartyAd ? null : forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.minLength(5), forms_1.Validators.maxLength(5)])],
            casualDating: ["true"],
            relationShips: [null],
            title: [null, forms_1.Validators.required],
            content: [null],
            nick: [null, forms_1.Validators.required],
            publish: [true],
            locationDescription: [null],
            termAccepted: [false],
            age: [null],
            selectedPersonType: [null, this.isThirdPartyAd ? null : forms_1.Validators.required]
        });
        this.advForm.get("postalCode").valueChanges.pipe(operators_1.debounceTime(1000)).subscribe(function (val) {
            _this.geolocationService.GetSubregionByZIP(val).then(function (response) {
                if (response) {
                    _this.subRegions = _this.services.advService.getSubRegionsByRegionId(response.regionId);
                    _this.advForm.get("region").patchValue(response.regionId);
                    _this.advForm.get("subregion").patchValue(response.subRegionId);
                }
                else {
                    _this.advForm.get("region").patchValue(null);
                    _this.advForm.get("subregion").patchValue(null);
                }
            });
        });
        if (!this.isPremiumFunctionality) {
            this.advForm.get('nick').valueChanges.subscribe(function (val) {
                if (!_this.isPremiumAd) {
                    _this.advForm.get("nick").patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
                }
            });
            this.advForm.get('content').valueChanges.subscribe(function (val) {
                if (!_this.isPremiumAd) {
                    _this.advForm.get("content").patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
                }
            });
            this.advForm.get('title').valueChanges.subscribe(function (val) {
                if (!_this.isPremiumAd) {
                    _this.advForm.get("title").patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
                }
            });
            this.advForm.get('age').valueChanges.subscribe(function (val) {
                if (!_this.isPremiumAd) {
                    _this.advForm.get("age").patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
                }
            });
        }
        var advId = Number(this.route.snapshot.paramMap.get("id"));
        this.services.advService.getCategories().then(function (r) {
            _this.categories = r;
            _this.regions = _this.services.advService.getRegionsOnly();
            if (!isNaN(advId) && advId > 0) {
                _this.get(advId);
            }
        });
        this.services.emojiService.emojis.then(function (result) {
            _this.emojis = result;
        });
        this.services.hideLoader(true);
        window.scroll(0, 0);
    };
    AdvEditComponent.prototype.categoryDisplayName = function (categoryId) {
        var category = this.categories.find(function (cat) { return cat.advertisementCategoryId == categoryId; });
        if (category == null) {
            return "";
        }
        if (this.isNew() || true) {
            return this.displayTexts[categoryId] != null ? this.displayTexts[categoryId] : "";
        }
        else {
            return category.name;
        }
    };
    Object.defineProperty(AdvEditComponent.prototype, "filteredCategories", {
        get: function () {
            var _this = this;
            var categories = this.categories;
            if (this.selectedPersonType != "" && this.selectedPersonType in this.personTypesMap) {
                categories = this.categories.filter(function (cat) { return _this.personTypesMap[_this.selectedPersonType].indexOf(cat.advertisementCategoryId) > -1; });
            }
            else if (this.isNew()) {
                categories = [];
            }
            return categories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isPremiumAd", {
        get: function () {
            if (this.adv == null) {
                return this._adType == AdType.Premium;
            }
            else {
                return this.adv.isPremium || this._adType == AdType.Premium;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isThirdPartyAd", {
        get: function () {
            if (this.adv == null) {
                return this._adType == AdType.ThirdParty;
            }
            else {
                return this.adv.isThirdParty || this._adType == AdType.ThirdParty;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "SpecialUser", {
        get: function () {
            if (this._specialUser == null) {
                this._specialUser = this.services.userService.isAdmin() || this.services.userService.isDemo() || this.services.userService.isPremium();
            }
            return this._specialUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isPremiumFunctionality", {
        get: function () {
            return this.isPremiumAd || this.SpecialUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isThirdPartyFunctionality", {
        get: function () {
            return this.isThirdPartyAd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "AdType", {
        get: function () {
            return this._adType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isUserDemo", {
        get: function () {
            if (this._isUserDemo == null) {
                this._isUserDemo = this.services.userService.isDemo();
            }
            return this._isUserDemo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isUserAdmin", {
        get: function () {
            if (this._isUserAdmin == null) {
                this._isUserAdmin = this.services.userService.isAdmin();
            }
            return this._isUserAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "isUserPremium", {
        get: function () {
            return this.services.userService.isPremium();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "HasUserPremiumAdToken", {
        get: function () {
            return this._userPremiumAdTokens > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "UserPremiumAdToken", {
        get: function () {
            return this._userPremiumAdTokens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "HasUserThirdPartyAdToken", {
        get: function () {
            return this._userThirdPartyAdTokens > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "UserThirdPartyAdToken", {
        get: function () {
            return this._userThirdPartyAdTokens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "AdView", {
        get: function () {
            return this._adView;
        },
        set: function (value) {
            this._adView = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "submitInProgress", {
        get: function () {
            return this._submitInProgress;
        },
        set: function (value) {
            this._submitInProgress = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "selectedImage", {
        get: function () {
            return this._selectedImage;
        },
        set: function (value) {
            if (value != this._selectedImage) {
                this.imagesChanged = true;
            }
            this._selectedImage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "IsDemoAd", {
        get: function () {
            return this._isDemoAd;
        },
        enumerable: true,
        configurable: true
    });
    AdvEditComponent.prototype.changeAdType = function (e) {
        this._adType = e.value;
        if (this._adType == AdType.Premium && this.UserPremiumAdToken == 0) {
            this.AdView = AdView.Payment;
        }
        else {
            this.AdView = AdView.Advertisement;
        }
        if (this._adType == AdType.Free) {
            this.clearPremiumElements();
        }
    };
    AdvEditComponent.prototype.clearPremiumElements = function () {
        this.advForm.get("content").patchValue(EmojiHelper_1.removeEmojis(this.advForm.get("content").value), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        this.advForm.get("title").patchValue(EmojiHelper_1.removeEmojis(this.advForm.get("title").value), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        if (this.images.length > 1) {
            this.images = [this.images[0]];
        }
    };
    AdvEditComponent.prototype.onChanges = function () {
        var _this = this;
        this.advForm.get("subregion").valueChanges.subscribe(function (val) {
            _this.advForm.get("postalCode").patchValue(_this.getZipCode(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        });
    };
    AdvEditComponent.prototype.onChangesSelect = function (e) {
        this.advForm.get("postalCode").patchValue(this.getZipCode(e.value), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
    };
    AdvEditComponent.prototype.getZipCode = function (subregionId) {
        var subregion = this.subRegions.find(function (x) { return x.subRegionId == subregionId; });
        if (subregion) {
            return subregion.zip;
        }
        return "";
    };
    AdvEditComponent.prototype.titleClick = function (e) {
    };
    AdvEditComponent.prototype.titleBlur = function (e) {
        if (e.target['selectionStart'] != null) {
            this.currentTitleCursorPosition = e.target['selectionStart'];
        }
    };
    AdvEditComponent.prototype.descriptionBlur = function (e) {
        if (e.target['selectionStart'] != null) {
            this.currentDescriptionCursorPosition = e.target['selectionStart'];
        }
    };
    AdvEditComponent.prototype.updateContent = function (text) {
        this.advForm.controls['content'].patchValue(text, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
    };
    AdvEditComponent.prototype.updateTitle = function (text) {
        this.advForm.controls['title'].patchValue(text, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
    };
    Object.defineProperty(AdvEditComponent.prototype, "filteredSubregion", {
        get: function () {
            if (!this.subRegions) {
                return [];
            }
            var search = this.subregionFilter.value;
            if (!search) {
                return this.subRegions;
            }
            else {
                return this.subRegions.filter(function (r) { return r.name.toLowerCase().indexOf(search) > -1; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "filteredRegions", {
        get: function () {
            if (!this.regions) {
                return [];
            }
            var search = this.regionFilter.value;
            if (!search) {
                return this.regions;
            }
            else {
                return this.regions.filter(function (r) { return r.name.toLowerCase().indexOf(search) > -1; });
            }
        },
        enumerable: true,
        configurable: true
    });
    AdvEditComponent.prototype.getInvalidFields = function () {
        var _this = this;
        var result = this.controlNames.map(function (control) {
            return { controlItem: control, control: _this.advForm.controls[control.name] };
        }).filter(function (c) { return c.control != null && !c.control.valid; });
        return result.map(function (c) { return c.controlItem.title; });
    };
    AdvEditComponent.prototype.addTitleEmoji = function (e) {
        var value = this.advForm.controls["title"].value;
        if (!value) {
            value = "";
        }
        if (this.currentTitleCursorPosition > -1 && value != "") {
            value = value.substring(0, this.currentTitleCursorPosition) + " " + e.emoji.native + " " + value.substring(this.currentTitleCursorPosition + 1, value.length);
        }
        else {
            value = e.emoji.native;
        }
        this.advForm.controls["title"].patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
    };
    AdvEditComponent.prototype.addDescriptionEmoji = function (e) {
        var value = this.advForm.controls["content"].value;
        if (!value) {
            value = "";
        }
        if (this.currentDescriptionCursorPosition > -1 && value != "") {
            value = value.substring(0, this.currentDescriptionCursorPosition) + " " + e.emoji.native + " " + value.substring(this.currentDescriptionCursorPosition + 1, value.length);
        }
        else {
            value = e.emoji.native;
        }
        this.advForm.controls["content"].patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
    };
    AdvEditComponent.prototype.addNewTitleEmoji = function (e) {
        if (e instanceof WickedApiClient_1.DTOEmoji) {
            var emojiCode = e.code;
            var value = this.advForm.controls["title"].value;
            if (!value) {
                value = "";
            }
            if (this.currentTitleCursorPosition > -1 && value != "") {
                value = value.substring(0, this.currentTitleCursorPosition) + " " + emojiCode + " " + value.substring(this.currentTitleCursorPosition + 1, value.length);
            }
            else {
                value = emojiCode;
            }
            this.advForm.controls["title"].setValue(value);
        }
    };
    AdvEditComponent.prototype.addNewDescriptionEmoji = function (e) {
        if (e instanceof WickedApiClient_1.DTOEmoji) {
            var emojiCode = e.code;
            var value = this.advForm.controls["content"].value;
            if (!value) {
                value = "";
            }
            if (this.currentDescriptionCursorPosition > -1 && value != "") {
                value = value.substring(0, this.currentDescriptionCursorPosition) + " " + emojiCode + " " + value.substring(this.currentDescriptionCursorPosition + 1, value.length);
            }
            else {
                value = emojiCode;
            }
            this.advForm.controls["content"].patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        }
    };
    AdvEditComponent.prototype.get = function (advId) {
        var _this = this;
        if (!this.advIsLoading) {
            this.advIsLoading = true;
            var advertisement = this.services.advService.searchDataUserAdv.resultList.find(function (a) { return a.advertisementId == advId; });
            if (advertisement != null) {
                this.bindAdvertisementToForm(advertisement);
            }
            else {
                this.services.advService.getAdvertisementData(advId).then(function (r) {
                    if (r && r.adveristments && r.adveristments.length == 1) {
                        if (r.adveristments[0].userId != _this.services.userService.getUserId() && !_this.isUserAdmin) {
                            _this.services.route.navigate([""]);
                        }
                        else {
                            _this.bindAdvertisementToForm(r.adveristments[0]);
                        }
                    }
                    else {
                        _this.services.route.navigate([""]);
                    }
                    _this.advIsLoading = false;
                }).catch(function (err) {
                    _this.services.showError(err);
                    _this.advIsLoading = false;
                });
            }
        }
    };
    AdvEditComponent.prototype.bindAdvertisementToForm = function (dto) {
        this.adv = new LocalModels_1.DTOAdvertisementEx();
        this.adv.init(dto);
        this.advForm.setValue({
            title: this.adv.title,
            content: this.adv.content,
            locationDescription: this.adv.locationDescription,
            age: this.adv.age,
            nick: this.adv.userNick,
            region: this.adv.regionId,
            subregion: this.adv.subRegionId,
            postalCode: this.adv.zipCode,
            casualDating: this.adv.casualDating ? "true" : "false",
            publish: this.adv.published ? "true" : "false",
            selectedPersonType: this.getPersonTypeByCategory(this.adv.advertisementCategoryId),
            termAccepted: false,
            relationShips: this.adv.advertisementCategoryId,
        });
        this.selectedPersonType = this.getPersonTypeByCategory(this.adv.advertisementCategoryId);
        //this.advForm.controls["relationShips"].setValue(this.adv.advertisementCategoryId);
        this.images = (this.adv.images || []).map(function (img) {
            var fi = new FileModels_1.FileInfo();
            fi.init(img);
            return fi;
        });
        this.setSelectedRegion(this.adv.regionId, true);
        this.images.sort(function (a, b) {
            return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
        });
        this.updateImageIndexes();
        if (this.images && this.images.length > 0) {
            this.selectedImage = this.images[0];
        }
        this.imagesChanged = false;
        this._adType = dto.isPremium ? AdType.Premium : (dto.isThirdParty ? AdType.ThirdParty : AdType.Free);
        this._isDemoAd = dto.isDemo;
        this._isExpired = !dto.isDemo && this.adv.dateStart && this.adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'));
        this.advForm.controls["selectedPersonType"].clearValidators();
        this.advForm.controls["selectedPersonType"].updateValueAndValidity();
        if (dto.isDemo) {
            this.advForm.controls["subregion"].clearValidators();
            this.advForm.controls["subregion"].updateValueAndValidity();
            this.advForm.controls["region"].clearValidators();
            this.advForm.controls["region"].updateValueAndValidity();
            this.advForm.controls["postalCode"].clearValidators();
            this.advForm.controls["postalCode"].updateValueAndValidity();
        }
    };
    AdvEditComponent.prototype.isMaxImagesExeeded = function () {
        if (this.isPremiumFunctionality || this.isThirdPartyAd) {
            return this.images.length >= 10;
        }
        else {
            return this.images.length >= 1;
        }
    };
    AdvEditComponent.prototype.setSelectedRegion = function (regionId, binding) {
        if (binding === void 0) { binding = false; }
        if (regionId) {
            // let rg = this.regions.filter(r => r.regionId == regionId);
            this.subRegions = this.services.advService.getSubRegionsByRegionId(regionId);
            if (this.adv) {
                this.advForm.controls["subregion"].patchValue(binding ? this.adv.subRegionId : null, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
            }
            else {
                this.advForm.controls["subregion"].patchValue(null, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
            }
        }
    };
    AdvEditComponent.prototype.updateImageIndexes = function () {
        this.images.forEach(function (img, index) {
            img.orderIndex = index;
        });
    };
    AdvEditComponent.prototype.drop = function (event) {
        if (event.previousIndex != event.currentIndex) {
            drag_drop_1.moveItemInArray(this.images, event.previousIndex, event.currentIndex);
            this.updateImageIndexes();
            this.imagesChanged = true;
        }
    };
    AdvEditComponent.prototype.isNew = function () {
        var adId = Number(this.route.snapshot.paramMap.get("id"));
        return isNaN(adId) || adId == 0;
    };
    Object.defineProperty(AdvEditComponent.prototype, "Expired", {
        get: function () {
            return this._isExpired;
        },
        enumerable: true,
        configurable: true
    });
    AdvEditComponent.prototype.onTokenAdded = function (response, thirdParty) {
        if (thirdParty === void 0) { thirdParty = false; }
        if (response.isError) {
            this.services.showError(response.message ? response.message : "Payment process error.");
        }
        else if (thirdParty) {
            this._adView = AdView.Advertisement;
            this._userThirdPartyAdTokens += 1;
        }
        else {
            this._adView = AdView.Advertisement;
            this._userPremiumAdTokens += 1;
        }
    };
    AdvEditComponent.prototype.adminRedirect = function () {
        if (this.previouseRouteService.getPreviousUrl() != this.router.url) {
            this.services.route.navigate([this.previouseRouteService.getPreviousUrl()]);
        }
        else {
            this.services.route.navigate(["search-results"]);
        }
    };
    AdvEditComponent.prototype.repostAd = function () {
        var _this = this;
        var repostModel = new WickedApiClient_1.AdvertistmentRepostModel();
        ;
        repostModel.init({
            manageId: this._manageId,
            advertisementId: this.adv.advertisementId,
            userId: this.adv.userId,
            userNick: this.advForm.controls["nick"].value,
            advertisementCategoryId: this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1,
            casualDating: this.advForm.controls["casualDating"].value == "true",
            content: this.advForm.controls["content"].value,
            images: this.images,
            published: this.advForm.controls["publish"].value == "true",
            regionId: Number(this.advForm.controls["region"].value),
            subRegionId: Number(this.advForm.controls["subregion"].value),
            title: this.advForm.controls["title"].value,
            age: this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null,
            seen: false,
            seenAdmin: false,
            isPremium: AdType.Premium ? true : false,
            isThirdParty: AdType.ThirdParty ? true : false,
            zipCode: this.advForm.controls["postalCode"].value,
            isDemo: false
        });
        this.services.advService
            .repost(repostModel)
            .then(function (response) {
            _this.submitInProgress = false;
            if (response.isReposted) {
                if (_this.isUserAdmin && !_this.isNew()) {
                    _this.adminRedirect();
                }
                else {
                    _this.services.route.navigate(["my-ads"]);
                }
            }
        })
            .catch(function (e) {
            _this.submitInProgress = false;
            _this.services.showError(e);
        });
    };
    AdvEditComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.captchaValid()) {
            this.services.showError("Check captcha");
            return false;
        }
        console.log(this.advForm.valid);
        if (!this.advForm.valid) {
            window.scrollTo(0, 0);
            this.services.showError("Some fields are invalid, fill them properly: " + this.getInvalidFields().join(","));
            return false;
        }
        this.submitInProgress = true;
        //repost ADV
        if (this.advForm.valid && this.Expired) {
            if (this.AdType == AdType.Premium && !this.SpecialUser) {
                if (!this.HasUserPremiumAdToken && !this.adTokenPaymentForm.form.valid) {
                    this.submitInProgress = false;
                    return;
                }
                if (this.HasUserPremiumAdToken) {
                    this.repostAd();
                }
                else {
                    this.adTokenPaymentForm.onTokenAdded.subscribe(function (response) {
                        if (response.isCreated) {
                            _this.repostAd();
                        }
                        else {
                            _this.services.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
                            _this.submitInProgress = false;
                        }
                    });
                    this.adTokenPaymentForm.onSubmit();
                }
            }
            else if (this.AdType == AdType.ThirdParty) {
                if (!this.HasUserThirdPartyAdToken && !this.adTokenPaymentForm.form.valid) {
                    this.submitInProgress = false;
                    return;
                }
                if (this.HasUserThirdPartyAdToken) {
                    this.repostAd();
                }
                else {
                    this.adTokenPaymentForm.onTokenAdded.subscribe(function (response) {
                        if (response.isCreated) {
                            _this.repostAd();
                        }
                        else {
                            _this.services.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
                            _this.submitInProgress = false;
                        }
                    });
                    this.adTokenPaymentForm.onSubmit();
                }
            }
            else {
                this.repostAd();
            }
        }
        else if (this.advForm.valid) {
            if (this.adv) {
                // update ADV
                if (this.selectedImage) {
                    var index = this.images.indexOf(this.selectedImage);
                    drag_drop_1.moveItemInArray(this.images, index, 0);
                    this.images.forEach(function (img, index) {
                        img.orderIndex = index;
                        img.isMain = false;
                    });
                    this.images[0].isMain = true;
                }
                this.services.advService
                    .update(this._manageId, this.adv.advertisementId, this.adv.userId, this.advForm.controls["nick"].value, this.advForm.controls["title"].value, this.advForm.controls["content"].value, Number(this.advForm.controls["region"].value), Number(this.advForm.controls["subregion"].value), this.advForm.controls["postalCode"].value, this.advForm.controls["casualDating"].value == "true", this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1, this.advForm.controls["publish"].value == "true", this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null, this.images, this.AdType == AdType.Premium ? true : false, this.AdType == AdType.ThirdParty ? true : false)
                    .then(function (r) {
                    _this.submitInProgress = false;
                    if (_this._manageId == null) {
                        if (_this.isUserAdmin) {
                            _this.adminRedirect();
                        }
                        else {
                            _this.services.route.navigate(["my-ads"]);
                        }
                    }
                    else {
                        _this.services.route.navigate([""]);
                    }
                })
                    .catch(function (e) {
                    _this.submitInProgress = false;
                    _this.services.showError(e);
                });
            }
            else {
                // create ADV
                this.services.advService
                    .create(this.advForm.controls["nick"].value, this.advForm.controls["title"].value, this.advForm.controls["content"].value, Number(this.advForm.controls["region"].value), Number(this.advForm.controls["subregion"].value), this.advForm.controls["postalCode"].value, this.advForm.controls["casualDating"].value == "true", this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1, this.advForm.controls["publish"].value == "true", this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null, this.images, this.AdType == AdType.Premium ? true : false, this.AdType == AdType.ThirdParty ? true : false)
                    .then(function (r) {
                    _this.submitInProgress = false;
                    _this.services.showThxDialog("my-ads");
                })
                    .catch(function (e) {
                    _this.submitInProgress = false;
                    _this.services.showError(e);
                });
            }
        }
    };
    AdvEditComponent.prototype.isImage = function (file) {
        var name = file.name.toLowerCase();
        return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
    };
    AdvEditComponent.prototype.uploadFile = function (file) {
        var _this = this;
        var url = "/File/TemporaryUpload";
        var formData = new FormData();
        var token = AuthHeaders_1.getAuthToken();
        var headers = new http_1.HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
        var httpRequestParams = new http_1.HttpParams();
        headers.set("Authorization", "Bearer " + token);
        formData.set("file", file.file, file.file.name);
        this.services.progress = true;
        this.HttpClient.post(url, formData, {
            headers: headers,
            observe: "events",
            params: httpRequestParams,
            reportProgress: true,
            responseType: "json"
        }).subscribe(function (event) {
            if (event.type === http_1.HttpEventType.UploadProgress) {
                file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
                file.loaded = event.loaded;
            }
            if (event.type == http_1.HttpEventType.Response) {
                var eventResponse = event;
                if (eventResponse.body && eventResponse.ok) {
                    file.fileName = eventResponse.body.files[0].localFilename;
                    file.isUploading = false;
                    file.imageUrl = environment_1.environment.apiBaseUrl + "/FileGet/" + file.fileName;
                }
                _this.services.progress = false;
            }
        }, function (error) {
            file.isUploading = false;
            _this.services.progress = false;
        }, function () {
        });
    };
    AdvEditComponent.prototype.getPersonTypeByCategory = function (categoryId) {
        var _this = this;
        var type = "";
        Object.keys(this.personTypesMap).forEach(function (personType) {
            if (_this.personTypesMap[personType].indexOf(categoryId) > -1) {
                type = personType;
            }
        });
        return type;
    };
    AdvEditComponent.prototype.addFile = function (file) {
        var _this = this;
        if (this.isImage(file)) {
            var fi = new FileModels_1.FileInfo();
            fi.file = file;
            fi.fileName = file.name;
            fi.name = file.name;
            fi.orgFileName = file.name;
            fi.advertisementId = this.adv ? this.adv.advertisementId : null;
            var reader = new FileReader();
            reader.onload = function (e) {
                if (_this.isMaxImagesExeeded()) {
                    return;
                }
                fi.imageUrl = reader.result;
                _this.images.push(fi);
                _this.updateImageIndexes();
                _this.uploadFile(fi);
                if (!_this.selectedImage) {
                    _this.selectedImage = fi;
                }
                _this.imagesChanged = true;
            };
            reader.readAsDataURL(fi.file);
        }
    };
    AdvEditComponent.prototype.deleteImage = function (file) {
        this.images = this.images.filter(function (x) { return x.orderIndex != file.orderIndex; });
        this.images.forEach(function (img, index) {
            img.orderIndex = index;
        });
        if (this.selectedImage == file) {
            if (this.images.length > 0) {
                this.selectedImage = this.images[0];
            }
            else {
                this.selectedImage = undefined;
            }
            //  this.selectedImage =
        }
        this.imagesChanged = true;
    };
    AdvEditComponent.prototype.cdkDragStarted = function (event, childItem, i) {
    };
    AdvEditComponent.prototype.cdkDragReleased = function (event, childItem, i) {
    };
    AdvEditComponent.prototype.overAction = function (i) {
    };
    AdvEditComponent.prototype.entered = function (event) {
    };
    AdvEditComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof forms_1.FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof forms_1.FormGroup) {
                _this.validateAllFormFields(control);
            }
        });
    };
    AdvEditComponent.prototype.bindAdvertisement = function (dto, manageId) {
        this._manageId = manageId;
        this.bindAdvertisementToForm(dto);
    };
    AdvEditComponent.prototype.tryDeleteAd = function () {
        var _this = this;
        this.services.showConfirm("Are you sure you want to delete this ad? You won't be able to restore it.").then(function (res) {
            if (res == confirmation_sheet_component_1.ConfirmationResult.Yes) {
                _this.services.advService.delete(_this.adv.advertisementId).then(function (res) {
                    _this.services.showInformation("Your ad was deleted");
                    if (_this.isUserAdmin) {
                        _this.adminRedirect();
                    }
                    else {
                        _this.services.route.navigate(["my-ads"]);
                    }
                }).catch(function (err) {
                    _this.services.showError(err);
                });
            }
        });
    };
    AdvEditComponent.prototype.onDropzoneUploadSuccess = function (event) {
        var file = event[0];
        var response = event[1];
        if (this.isImage(file)) {
            var fi = new FileModels_1.FileInfo();
            fi.file = file;
            fi.fileName = file.name;
            fi.name = file.name;
            fi.orgFileName = file.name;
            fi.advertisementId = this.adv ? this.adv.advertisementId : null;
            fi.imageUrl = environment_1.environment.apiBaseUrl + "/FileGet/" + response.files[0].localFilename;
            this.images.push(fi);
            this.updateImageIndexes();
            //this.uploadFile(fi);
            if (!this.selectedImage) {
                this.selectedImage = fi;
            }
            this.imagesChanged = true;
        }
    };
    AdvEditComponent.prototype.onUploadError = function (event) {
    };
    Object.defineProperty(AdvEditComponent.prototype, "dragOn", {
        get: function () {
            return this._dragOn;
        },
        enumerable: true,
        configurable: true
    });
    AdvEditComponent.prototype.dragleave = function (event) {
        this._dragOn = false;
    };
    AdvEditComponent.prototype.dragover = function (event) {
        this._dragOn = false;
    };
    AdvEditComponent.prototype.dragenter = function (event) {
        this._dragOn = false;
    };
    Object.defineProperty(AdvEditComponent.prototype, "dropzoneConfig", {
        get: function () {
            return DropzoneHeper_1.DEFAULT_DROPZONE_CONFIG;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvEditComponent.prototype, "termsNotAccepted", {
        get: function () {
            return this._termsNotAccepted;
        },
        set: function (value) {
            this._termsNotAccepted = value;
        },
        enumerable: true,
        configurable: true
    });
    AdvEditComponent.prototype.getCaptchaResolvedFlag = function () {
        return this._captchaResolvedFlag;
    };
    AdvEditComponent.prototype.setCaptchaResolvedFlag = function (value) {
        this._captchaResolvedFlag = value;
    };
    AdvEditComponent.prototype.captchaAvailable = function () {
        return (this.captchaService.getCurrentCaptchaKey() != "");
    };
    AdvEditComponent.prototype.captchaResolved = function (captchaResponse) {
        this.setCaptchaResolvedFlag(true);
    };
    AdvEditComponent.prototype.termsAcceptAction = function (e) {
        this.termsNotAccepted = !e.checked;
    };
    AdvEditComponent.prototype.captchaValid = function () {
        return !this.captchaAvailable() || (this.captchaAvailable() && this._captchaResolvedFlag);
    };
    return AdvEditComponent;
}());
exports.AdvEditComponent = AdvEditComponent;
